// src/components/ApplicationForm.js
import React, { useEffect } from 'react';

const ApplicationForm = () => {
    useEffect(() => {
        // Function to load scripts sequentially
        const loadScript = (src) => {
            return new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.src = src;
                script.type = 'text/javascript';
                script.onload = resolve;
                script.onerror = reject;
                document.head.appendChild(script);
            });
        };

        // Load jQuery first, then the form script
        const loadScripts = async () => {
            try {
                // Load jQuery from CDN
                await loadScript('https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.0/jquery.min.js');
                
                // After jQuery is loaded, load the form script
                const formScript = document.createElement('script');
                formScript.id = 'ctplleadfrm298452678f31aaf3f11';
                formScript.src = 'https://admission.maya.edu.in/default/js/frontend/ctplenqueryform.js';
                formScript.type = 'text/javascript';
                document.head.appendChild(formScript);
                
                // Initialize form after a short delay to ensure scripts are loaded
                setTimeout(() => {
                    if (window.ctplTag) {
                        window.ctplTag("298452678f31aaf3f11");
                    }
                }, 1000);
            } catch (error) {
                console.error('Error loading scripts:', error);
            }
        };

        loadScripts();

        // Cleanup function
        return () => {
            const scripts = [
                document.getElementById('ctplleadfrm298452678f31aaf3f11'),
                document.querySelector('script[src*="jquery"]')
            ];
            
            scripts.forEach(script => {
                if (script) {
                    script.remove();
                }
            });
        };
    }, []);

    return <div id="cont298452678f31aaf3f11"></div>;
};

export default ApplicationForm;
